import { action } from 'mobx'
import axios from "axios/index";
import {Common as util} from "../utils/common";
import gql from "../utils/gql";


export class Product {


  // 상품 옵션 조회 (리뷰 작성 시 옵션 선택용) — cafe24 응답 그대로 { data: { options: {...} } }
  @action getCafe24ProductOptions = (data, cb) => {

    let property = ['store_id', 'shopNo', 'platformProductId'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getCafe24ProductOptions',
      variables: variables,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            if(res.data.errors && res.data.errors.length > 0) {
              cb({ errors: res.data.errors });
            }
            else {
              cb(res.data.data[params.operation]);
            }
          }
          else {
            return res.data.data[params.operation];
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        if(typeof cb === 'function') {
          cb({ errors: [{ message: error.message }] });
        }
        return error;
      });
  };

  @action getProductList = (data, cb) => {

    let property = ['store_id', 'shopNo', 'limit', 'page', 'sort', 'searchParams'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getProductList',
      variables: variables,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }

      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };



  @action setProductSync = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'setProductSync',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(typeof cb === 'function') {
          cb(res.data.data[params.operation]);
        }
        else {
          return res.data.data[params.operation];
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };

  @action getProductGroupList = (data, cb) => {

    let property = ['store_id', 'shopNo', 'limit', 'page', 'sort', 'searchParams'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getProductGroupList',
      variables: variables,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }

      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };
  @action updateProductGroup = (data, cb) => {
    if(data._id) data.id = data._id;
    let property = ['id', 'store_id', 'shopNo', 'parentProduct_ids', 'childProduct_ids', 'product_ids', 'name', 'type']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'updateProductGroup',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(typeof cb === 'function') {
          cb(res.data.data[params.operation]);
        }
        else {
          return res.data.data[params.operation];
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };

  @action updateProductReplay = (data, cb) => {
    if(data._id) data.id = data._id;
    if(data.tone) {
      data.tone = util.escapeGraphQLString(data.tone);
    }

    let property = ['id', 'store_id', 'product_id', 'type', 'tone']
    let variables = util.getDataStByKey(data, property);
    let params = {
      type: 'mutation',
      operation: 'updateProductReplay',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  // 상품별 리뷰 작성 설정
  @action updateProductReviewConfig = (data, cb) => {
    let property = ['store_id', 'product_id', 'isReviewWriteDisabled'];
    let variables = util.getDataStByKey(data, property);
    let params = {
      type: 'mutation',
      operation: 'updateProductReviewConfig',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if (typeof cb === 'function') cb(res.data.data[params.operation]);
          else return res.data.data[params.operation];
        })
        .catch(function (error) {
          if (typeof cb === 'function') cb(error);
          return error;
        });
  };

  @action removeProductGroup = (data, cb) => {
    if(data._id) data.id = data._id;
    let property = ['id', 'store_id']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'removeProductGroup',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(typeof cb === 'function') {
          cb(res.data.data[params.operation]);
        }
        else {
          return res.data.data[params.operation];
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };

  @action latestOderUpdate = (data, cb) => {

    let variables = data;

    let params = {
      type: 'mutation',
      operation: 'latestOderUpdate',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation])
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };



  @action getOrderFormPlatform = (data, cb) => {

    let variables = data;

    let params = {
      type: 'mutation',
      operation: 'getOrderFormPlatform',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation])
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action adminProductImgDomainUpdate = (data, cb) => {

    let property = ['store_id', 'shopNo', 'fromDomain', 'toDomain']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'adminProductImgDomainUpdate',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation].data;
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };



}
